<template>
	<div class="box-max">
		<div class="goback">
			<el-button  style="border:none"  @click="gotoback">
				<i  class="el-icon-arrow-left"></i>
				<span > {{$t('Back')}} </span>
			</el-button>
		</div>
		<div class="wp-title">{{ $t('Check your phone for a code') }}</div>
		<div class="sub-title">
			{{ $t('We are sent a 6-character code to') }}
			+{{ this.$route.params.country_code}}
			{{ this.$route.params.phone}}
			{{ $t('The code expires shortly so please enter it soon')}}
		</div>
		<!-- <div class="input-box">
			<div class="input-content" @keydown="keydown" @keyup="keyup" @paste="paste" @mousewheel="mousewheel"
				@input="inputEvent">
				<input max="9" min="0" maxlength="1" data-index="0" v-model.trim.number="input[0]" type="number"
					ref="firstinput"/>
					<input max="9" min="0" maxlength="1" data-index="1" v-model.trim.number="input[1]" type="number"/>
					<input max="9" min="0" maxlength="1" data-index="2" v-model.trim.number="input[2]" type="number"/>
					<input max="9" min="0" maxlength="1" data-index="3" v-model.trim.number="input[3]" type="number"/>
					<input max="9" min="0" maxlength="1" data-index="4" v-model.trim.number="input[4]" type="number"/>
					<input max="9" min="0" maxlength="1" data-index="5" v-model.trim.number="input[5]" type="number"/>
			</div>
			<div class="input-split">
				<div></div>
			</div>
		</div> -->
		<div class="input-box">
			<div class="input-content" >

				<el-form @submit.native.prevent :model="form" :rules="rules" ref="ruleForm">
					<el-form-item  prop="verification" class="wp-item" >
							<el-input  maxlength="6"   v-model="form.verification" oninput="value=value.replace(/\D/gi,'')" @change="onchangeinput" class="wp-input input-with-send">
							</el-input>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="continue-btn">
			<div style="text-align: center">
				<span class="fail msg" v-if="status === false">{{ $t('That code was not valid. Give it another go') }}</span>
				<span class="success msg" v-if="status === true">{{ $t('Success') }} !</span>
			</div>
			<el-button class="wp-button primary" @click="verifyClick">{{ $t('Continue') }}</el-button>
		</div>
	</div>
</template>

<script>
	import { verifyCodeLogin ,recordClick} from '../api';
	import { loadingData, EventBus ,getTimeZoneCity } from '../utils';
	import { setStore, getStore, keys } from '../store';
	import { setUser } from '../store/user';
	import { LoginRedirect } from '../services/redirectService';

	export default {
		data() {
			return {
				// code: [null, null, null, null, null, null],
				phone: '',
				country_code: '',
				status: null,
				pasteResult: [], // 存放粘贴进来的数字

				inputcode: '',
				code: '',
				form:{
					verification:''
				},
				rules: {
					verification:[
						{ required: true, message: '', trigger: 'blur'  },
						{ max:6,min:6, message: '', trigger: 'blur' },
					]
				},
			};
		},
		mounted() {
			this.phone = this.$route.params.phone;
			this.country_code = this.$route.params.country_code;
			// window.addEventListener('input', this.change);
			// window.addEventListener('keyup', this.changePop);
		},
		computed: {
			input () {
			// code 是父组件传进来的默认值，必须是6位长度的数组，这里就不再做容错判断处理
			// 最后空数组是默认值
			return this.pasteResult.length === 6 ? this.pasteResult : ['', '', '', '', '', '']
			}
		},
		methods: {
			onchangeinput(e){
				this.$set(this.form, this.form.verification, e)
			},
			gotoback(){
				 history.back();
			},
			changePop(e) {
				if (e.keyCode === 8) this.pop();
			},
			change(e) {
				if (e.inputType === 'insertText' && e.data >= 0 && e.data <= 9) {
					let key = parseInt(e.data);
					this.append(key);
				}
			},
			append(key) {
				let index = this.code.indexOf(null);
				if (index >= 0) this.$set(this.code, index, key);
			},
			pop() {
				let index = this.code.indexOf(null);
				if (index <= 0) index = this.code.length;
				if (index - 1 < 0) return;
				this.$set(this.code, index - 1, null);
			},
			async verifyClick() {
				await loadingData(async () => {
					try {
						let userInfo = await verifyCodeLogin(this.phone, this.form.verification, this.country_code,getTimeZoneCity());
						setStore(keys.userInfo, userInfo);
						setStore(keys.token, userInfo.token);
						await setUser();
						EventBus.$emit('login');

						if (userInfo.is_register){
							// await recordClick(2,userInfo.user_sn);
						}
						setTimeout(() => {
							if (userInfo.is_register) this.$router.push({ path: '/profile' });
							else {
								LoginRedirect();
							}
						}, 1000);
					} catch (error) {
						this.status = false;
					}
				});
			},
			inputClick() {
				this.$refs.input.focus();
			},
			// 验证码
			// 解决一个输入框输入多个字符
			inputEvent (e) {
				var index = e.target.dataset.index * 1
				var el = e.target
				this.$set(this.input, index, el.value.slice(0, 1))
			},
			keydown (e) {
				var index = e.target.dataset.index * 1
				var el = e.target
				if (e.key === 'Backspace') {
					if (this.input[index].length > 0) {
					this.$set(this.input, index, '')
					} else {
					if (el.previousElementSibling) {
						el.previousElementSibling.focus()
						this.$set(this.input, index - 1, '')
					}
					}
				} else if (e.key === 'Delete') {
					if (this.input[index].length > 0) {
					this.$set(this.input, index, '')
					} else {
					if (el.nextElementSibling) {
						this.$set(this.input, index = 1, '')
					}
					}
					if (el.nextElementSibling) {
					el.nextElementSibling.focus()
					}
				} else if (e.key === 'Home') {
					el.parentElement.children[0] && el.parentElement.children[0].focus()
				} else if (e.key === 'End') {
					el.parentElement.children[this.input.length - 1] && el.parentElement.children[this.input.length - 1].focus()
				} else if (e.key === 'ArrowLeft') {
					if (el.previousElementSibling) {
					el.previousElementSibling.focus()
					}
				} else if (e.key === 'ArrowRight') {
					if (el.nextElementSibling) {
					el.nextElementSibling.focus()
					}
				} else if (e.key === 'ArrowUp') {
					if (this.input[index] * 1 < 9) {
					this.$set(this.input, index, (this.input[index] * 1 + 1).toString())
					}
				} else if (e.key === 'ArrowDown') {
					if (this.input[index] * 1 > 0) {
					this.$set(this.input, index, (this.input[index] * 1 - 1).toString())
					}
				}
			},
			keyup (e) {
				var index = e.target.dataset.index * 1
				var el = e.target
				if (/Digit|Numpad/i.test(e.code)) {
					this.$set(this.input, index, e.code.replace(/Digit|Numpad/i, ''))
					el.nextElementSibling && el.nextElementSibling.focus()
					if (index === 5) {
					if (this.input.join('').length === 6) {
						document.activeElement.blur()
						// this.$emit('complete', this.input);
					}
					}
				} else {
					if (this.input[index] === '') {
					this.$set(this.input, index, '')
					}
				}
			},
			mousewheel (e) {
				var index = e.target.dataset.index
				if (e.wheelDelta > 0) {
					if (this.input[index] * 1 < 9) {
					this.$set(this.input, index, (this.input[index] * 1 + 1).toString())
					}
				} else if (e.wheelDelta < 0) {
					if (this.input[index] * 1 > 0) {
					this.$set(this.input, index, (this.input[index] * 1 - 1).toString())
					}
				} else if (e.key === 'Enter') {
					if (this.input.join('').length === 6) {
					document.activeElement.blur()
					// this.$emit('complete', this.input);
					}
				}
			},
			paste (e) {
				// 当进行粘贴时
				e.clipboardData.items[0].getAsString(str => {
					if (str.toString().length === 6) {
					this.pasteResult = str.split('')
					document.activeElement.blur()
					// this.$emit('complete', this.input);
					}
				})
			}
		},
	};
</script>

<style lang="less" scoped>
	@media screen and (min-width: @device) {
		.goback{
			display: none;
		}
		.input-content {
			display: flex;
			flex-direction: row;
			width: 100%;
			.el-form{
				width: 70%;
				margin: 0 auto;
			}
			input {
				// color: inherit;
				// font-family: Sofia Pro-Regular;
				outline: 0;
				// font-size: 28px;
				text-align: center;

				border: 1px solid #cfcfcf;
				border-right:none;
				// width: 75px;
				font-weight: 600;
				display: flex;
				flex-direction: row;
				justify-content: center;
				align-items: center;
				text-align: center;

				&:first-child,&:nth-child(4) {
					border-radius: 5px 0 0 5px;
				}

				&:last-child,&:nth-child(3) {
					border-radius: 0 5px 5px 0;
				}
				&:nth-child(3n){
					margin-right:40px;
					border-right: 1px solid #cfcfcf;
				}
			}
		}
		.input-box {
			width: 495px;
			input{
				height: 55px;
				width: 55px;
				padding:10px;
				font-size: 2.7rem;
			}
		}
	}



	.wp-title {
		margin-top: 36px;
	}

	.sub-title {
		font-size: 1.2rem;
		line-height: 22px;
		text-align: center;
		margin: 21px 5% 0;
	}

	.input-split {
		display: flex;
		flex-direction: column;
		justify-content: center;
		position: absolute;
		left:50%;
		top:50%;
		margin-left:-10px;

		> div {
			width: 20px;
			height: 1px;
			border-top: 1px solid #cfcfcf;
		}
	}

	.continue-btn {
		width: 372px;
		margin: 90px auto;
		height: 80px;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
	}

	.msg {
		position: relative;
		display: inline-block;
		padding-left: 25px;

		&::before {
			content: '';
			width: 20px;
			height: 20px;
			position: absolute;
			background-size: contain;
			left: 0;
			top: 2px;
		}

		&.success {
			color: #34b233;

			&::before {
				background-image: url(../assets/img/success.png);
				background-repeat: no-repeat;
			}
		}

		&.fail {
			color: #ff0000;

			&::before {
				background-image: url(../assets/img/fail.png);
				background-repeat: no-repeat;
			}
		}
	}

	.wp-button {
		margin-top: 20px;
	}
	.input-box {
		display: flex;
		flex-direction: row;
		// width: 495px;
		margin: 44px auto 0;
		justify-content: space-between;
		position: relative;


		input::-webkit-outer-spin-button,
		input::-webkit-inner-spin-button {
		appearance: none;
		margin: 0;
		}
	}
	// 移动端
	@media screen and (max-width: @device) {
		.box-max{
			padding: 0 10px;

		}
		.continue-btn{
			width: 100%;
			max-width: 410px;
		}
		.goback{
			margin-top: 20px;
			span{
				font-family: 'Poppins';
                font-style: normal;
               font-weight: 600;
               font-size: 14px;
                line-height: 20px;
				color: #B60504;
			}
		}

		.input-box {
			margin-top: 0px;
			width: 100%;
			padding: 0;
			input{
				width: 40px;
				height: 40px;
				padding:5px;
				font-size: 2rem;
			}
		}
		.sub-title{
			width: 100%;
            height: 40px;
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
			margin: 21px auto;
		}
		.input-content{
			margin: 75px auto 0;
			padding: 0;
			width: 374px;

			input{
				height: 80px;
				margin-left: 6px;
				border: 1px solid #cfcfcf;
				border-radius: 8px;
				box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
				text-align: center;
			}
		}
		.input-split{
			display: none;
		}
		.continue-btn{
			margin-top: 100px;
		}
		.continue-btn /deep/.el-button--default{
            font-weight: 500;
            font-size: 18px;
            line-height: 28px;
			span{
				font-family: 'Sofia Pro';
			}
		}
	}



	/deep/.el-input /deep/.el-input--suffix/deep/ .el-input__inner{
			color: #101828;
		}
		/deep/.el-input__inner{
			color: #667085;
		}
		.wp-input input-with-select{
			color: #101828;
		}
		/deep/.el-form-item{
			margin-top: 20px;
		}

	/deep/.el-input.is-active .el-input__inner, /deep/.el-input__inner:focus{
		 border:1px solid hsl(0, 0%, 0%);
	}
	/deep/.el-input-group__prepend:focus{
		 border:1px solid hsl(0, 0%, 0%);
	}
	/deep/.el-input-group__prepend:focus-within{
		 border:1px solid hsl(0, 0%, 0%);
	}
	/deep/.wp-input .el-input-group__prepend{
		border-radius: 0px;
	}
	/deep/.el-input-group__prepend{
		background: #FFFFFF;
	}
	/deep/.input-with-send {
		input{
			border-radius:6px;
			// border-right:none;
		}
	}
   /deep/.wp-input{
	.el-input-group__append{
		background:  #FFFFFF;
		font-family: 'Sofia Pro';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		line-height: 22px;
		color: #4B69FE;

	}
   }
   /deep/.el-input__inner{
	   border-color: #C0C4CC;
   }
   /deep/.wp-input .el-input-group__append:focus-within{
	border: 1px  solid hsl(0, 0%, 0%);
   }
   /deep/ .wp-input .el-input-group__append:focus{
	border: 1px  solid hsl(0, 0%, 0%);
   }
</style>



// WEBPACK FOOTER //
// src/views/VerifyPhone.vue